var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcSettingsSection',{attrs:{"title":_vm.t('activity', 'Activity'),"description":_vm.settingDescription}},[_c('ActivityGrid'),_vm._v(" "),_c('EmailSettings')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }